<div class="container-fluid dashboard-alt">

  <!-- ================= GLOBAL PERIOD TOGGLE ================= -->
  <div class="d-flex justify-content-end align-items-center mb-3 dashboard-period-toggle">
    <div class="toggle-box">
      <span
        [class.active]="activePeriod === 'monthly'"
        (click)="changePeriod('monthly')">
        Month
      </span>
      <span
        [class.active]="activePeriod === 'yearly'"
        (click)="changePeriod('yearly')">
        Year
      </span>
    </div>
  </div>

  <!-- ================= KPI CARDS ================= -->
  <div class="row g-4 mb-4">
    <div class="col-xl-3 col-md-6" *ngFor="let kpi of businessKpi">
      <mat-card class="kpi-card" [style.--accent]="kpi.bgColor">

        <!-- ICON -->
        <div class="kpi-icon">
          <mat-icon>{{ kpi.icon }}</mat-icon>
        </div>

        <!-- KPI CONTENT -->
        <div class="kpi-center">
          <p class="kpi-title">
            {{ kpi.label }}
            <span>
              ({{ currentPeriodLabel }})
            </span>
          </p>

          <h2 class="kpi-value">
            {{
              kpi.hasPeriod
                ? (activePeriod === 'yearly' ? kpi.yearly : kpi.monthly)
                : kpi.value
            }}
          </h2>
        </div>

      </mat-card>
    </div>
  </div>

  <!-- ================= STATUS / PIPELINE CARDS ================= -->
  <div class="row g-4">
    <div class="col-xl-4 col-md-6" *ngFor="let card of pipeline">
      <mat-card class="status-card">

        <!-- HEADER -->
        <div class="status-header">
          <h4>
            {{ card.title }}
            <span class="period-tag" *ngIf="card.periodAware">
              {{ currentPeriodLabel }}
            </span>
          </h4>
        </div>

        <!-- STATUS LIST -->
        <div
          class="status-pill"
          *ngFor="let s of card.statuses"
          [ngClass]="s.type"
          (click)="onStatusClick($event, card.title, s.label, s.value)">
          <span class="icon">{{ s.icon }}</span>
          <span class="label">{{ s.label }}</span>
          <strong class="value">{{ s.value }}</strong>
        </div>

      </mat-card>
    </div>
  </div>

  <!-- ================= ALERT SECTION ================= -->
  <div class="row mt-4" *ngIf="alerts.length">
    <div class="col-12">
      <mat-card class="alert-card">
        <h4>⚠ Attention Required</h4>
        <ul>
          <li *ngFor="let alert of alerts">
            {{ alert.message }}
          </li>
        </ul>
      </mat-card>
    </div>
  </div>

</div>
